import { useQuery } from "react-query";
import { fetchData } from "../api/client";

/** Monta querystring a partir de um objeto de filtros */
const toQS = (obj = {}) => {
  const sp = new URLSearchParams();

  Object.entries(obj).forEach(([k, v]) => {
    if (v === null || v === undefined) return;

    if (Array.isArray(v)) {
      const arr = v.map(x => (x ?? "").toString().trim()).filter(x => x !== "");
      if (arr.length) sp.set(k, arr.join(","));
    } else {
      const s = String(v).trim();
      if (s) sp.set(k, s);
    }
  });

  const qs = sp.toString();
  return qs ? `?${qs}` : "";
};

/**
 * Padrão único para todas as abas do dashboard
 * - Sempre desembrulha a resposta do fetchData: usa `resp.data ?? resp`
 * - O `options.select`, se fornecido, recebe o payload já desembrulhado
 */
export const useDashboard = (scope, subpath, params = {}, options = {}) => {
  const qs = toQS(params);
  const key = ["dashboard", scope, subpath, params];

  const userSelect = options.select;
  const normalizedSelect = (resp) => {
    const inner = resp?.data ?? resp; // pode ser OBJETO ou ARRAY

    // fetchData já desembrulha o envelope { message, data } e devolve
    // { data, pagination, totalInDatabase }. Para endpoints paginados
    // precisamos preservar pagination/totalInDatabase, senão o select do
    // consumidor perderia esses campos (causando rows/total vazios).
    const hasPaginationMeta =
      resp &&
      typeof resp === "object" &&
      !Array.isArray(resp) &&
      (resp.pagination !== undefined || resp.totalInDatabase !== undefined);

    let payload;
    if (hasPaginationMeta) {
      payload = Array.isArray(inner)
        ? { data: inner, pagination: resp.pagination, totalInDatabase: resp.totalInDatabase }
        : { ...(inner || {}), pagination: resp.pagination, totalInDatabase: resp.totalInDatabase };
    } else {
      payload = inner;
    }

    return userSelect ? userSelect(payload) : payload;
  };

  return useQuery(
    key,
    async () => {
      const url = `/dashboard/${scope}/${subpath}${qs}`;
      return fetchData(url);
    },
    {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      ...options,
      select: normalizedSelect, // garante nosso wrapper
    }
  );
};
